import React from 'react';
import WeaveProvider from './WeaveContext/WeaveProvider';
export default function InnoWeaveThemeConnector({ children, hasWeaveTheme = false, }) {
    if (!hasWeaveTheme)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(WeaveProvider, { hasWeaveTheme: true }, children);
}
